import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  const sideBar = document.querySelector('.bbs-sidebar');
  if (!sideBar) return;
  const openButton = document.querySelector('.bbs-sidebar-open-button');
  const closeButton = document.querySelector('.bbs-sidebar__close-button');

  const overlay = document.querySelector('.bbs-sidebar__overlay');
  const sidebarActiveClass = 'bbs-sidebar--active';

  overlay.addEventListener('click', () => {
    sideBar.classList.remove(sidebarActiveClass);
  });

  openButton.addEventListener('click', () => {
    sideBar.classList.toggle(sidebarActiveClass);
  });

  closeButton.addEventListener('click', () => {
    sideBar.classList.toggle(sidebarActiveClass);
  });

  const initSwiper = (target) => {
    target.querySelectorAll('.swiper.bbs-plan-show__swiper').forEach((swiperEl) => {
      if (swiperEl.swiper) {
        // Swiper が既に初期化済みなら autoplay を再開
        swiperEl.swiper.autoplay?.start();
        return;
      }
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        pagination: {
          el: swiperEl.querySelector('.bbs-plan-show__swiper-pagination'),
          bulletClass: 'bbs-plan-show__swiper-pagination-bullet',
          bulletActiveClass: 'bbs-plan-show__swiper-pagination-bullet--active',
          clickable: true,
        },
      });
    });
  };

  const moreView = (target) => {
    const descriptions = target.querySelectorAll('.bbs-plan-show__description');
    descriptions.forEach((description) => {
      const text = description.querySelector('.bbs-plan-show__description-text');
      const moreButton = description.querySelectorAll('.bbs-plan-show__description-toggle-button')[0];
      const closeButton = description.querySelectorAll('.bbs-plan-show__description-toggle-button')[1];
      const screenWidth = window.innerWidth;
      const heightThreshold = screenWidth >= 1024 ? 223 : 148;
      // 高さチェックで data-has-more を更新
      if (text.scrollHeight > heightThreshold) {
        description.setAttribute('data-has-more', 'true');
      } else {
        description.setAttribute('data-has-more', 'false');
      }
      // 「続きを読む」ボタン（展開）
      if (moreButton) {
        moreButton.addEventListener('click', () => {
          description.setAttribute('data-is-expanded', 'true');
        });
      }
      // 「閉じる」ボタン（折りたたみ）
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          description.setAttribute('data-is-expanded', 'false');
        });
      }
    });
  };
  // 初期化（初期表示されているタブ用）
  const initialActiveTab = document.querySelector('.bbs__plan-show--active');
  if (initialActiveTab) {
    moreView(initialActiveTab);
    initSwiper(initialActiveTab);
  }

  // タブ切り替え処理
  const tabButtons = document.querySelectorAll('.bbs-day-tab__button');
  const tabContents = document.querySelectorAll('.bbs__plan-show');
  if (tabButtons.length) {
    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.swiper.bbs-plan-show__swiper').forEach((swiperEl) => {
          if (swiperEl.swiper) {
            swiperEl.swiper.autoplay?.stop();
          }
        });
        tabButtons.forEach((btn) => btn.classList.remove('bbs-day-tab__button--active'));
        tabContents.forEach((content) => content.classList.remove('bbs__plan-show--active'));
        button.classList.add('bbs-day-tab__button--active');
        const tabId = button.dataset.day;
        const target = document.querySelector(`.bbs__plan-show[data-day="${tabId}"]`);
        target.classList.add('bbs__plan-show--active');
      });
    });
  }
  // ResizeObserver：アクティブタブの描画完了を監視
  tabContents.forEach((tab) => {
    const observer = new ResizeObserver(() => {
      if (tab.classList.contains('bbs__plan-show--active')) {
        requestAnimationFrame(() => {
          moreView(tab);
          initSwiper(tab);
        });
      }
    });
    observer.observe(tab);
  });

  document.querySelectorAll('.bbs-pick-up-section__swiper').forEach((swiperEL) => {
    new Swiper(swiperEL, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: '.bbs-swiper-nav--next',
        prevEl: '.bbs-swiper-nav--prev',
      },
    });
  });
});
